/*
 * beni-scroll-lock —— body.style.overflow 引用计数锁
 *
 * 修复既有 bug: sections/beni-popup.liquid、catbar/抽屉等多处直接 body.style.overflow='hidden',
 * 关闭时无脑清空 → 先开后关的组件会把仍持锁的组件误解锁 (catbar-open → popup-open → catbar-close
 * 后 popup 的锁被清).
 *
 * 用法:
 *   window.__beniScrollLock.acquire('my-owner-key')  // 引用计数 +1, 首次上锁
 *   window.__beniScrollLock.release('my-owner-key')  // 引用计数 -1, 归零解锁
 *
 * 幂等: 同一 owner 多次 acquire 不重复计数; 未 acquire 就 release 无副作用.
 */
(function () {
  if (window.__beniScrollLock) return;

  var owners = Object.create(null);
  var savedOverflow = null;

  function lockCount() {
    var n = 0;
    for (var k in owners) if (owners[k]) n++;
    return n;
  }

  window.__beniScrollLock = {
    acquire: function (owner) {
      if (!owner) return;
      if (owners[owner]) return;             // 幂等: 已持锁
      owners[owner] = true;
      if (lockCount() === 1) {
        savedOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
      }
    },
    release: function (owner) {
      if (!owner || !owners[owner]) return;  // 未持锁
      owners[owner] = false;
      if (lockCount() === 0) {
        document.body.style.overflow = savedOverflow || '';
        savedOverflow = null;
      }
    },
    // 调试用
    _owners: function () { return Object.keys(owners).filter(function (k) { return owners[k]; }); },
  };
})();
